import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { AppFeatureService, AppService } from '@nk/access-block';
import { GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { AppFeatureDims, AppMembershipEntity } from '@nk/data-entities-lib';
import { simplifyCompanyName } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'nk-user-menu-mobile',
  templateUrl: './user-menu-mobile.component.html',
  styleUrls: ['./user-menu-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class UserMenuMobileComponent implements OnInit {
  @Input() public collapsedNav: boolean;
  @Input() public dropdownId: string;
  @Input() public hideNavItems = {};

  public loggedInWithIdentityProvider = false;
  public customerName$: Observable<string>;
  public appMembershipList$: Observable<AppMembershipEntity[]>;
  public activeFeatureDims$: Observable<AppFeatureDims>;
  constructor(
    private _appService: AppService,
    private _appFeatureService: AppFeatureService,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
  ) {}

  public ngOnInit(): void {
    this.loggedInWithIdentityProvider =
      this._authService.authInfo.idTokenPayload && this._authService.authInfo.idTokenPayload.sub.startsWith('waad|');
    this.activeFeatureDims$ = this._appFeatureService.activeAppFeatureDimsCache.get();

    this.customerName$ = this._appService.identityDataCache.get().pipe(
      map((identity) => {
        let customerName = simplifyCompanyName(identity.app_customer.name); // Removes AS, ASA etc
        if (customerName.length > 37) {
          customerName = customerName.substring(0, 40);
          customerName = customerName + '...';
        }
        return customerName;
      }),
    );
    this.appMembershipList$ = this._appService.identityDataCache.get().pipe(
      switchMap((appIdentity) => {
        return this._appService.appMembershipListByUserCache.get(appIdentity.app_user.uuid);
      }),
    );
  }

  public logout(logOutOfMicrosoft = false): void {
    this._authService.logout('userLogout', null, logOutOfMicrosoft);
  }
  public onChangeAccount(): void {
    this._authService.removeCustomerSlug();
    window.location.replace('/login'); // a hard http replace will "delete" all angular cache.
  }
}
